import isFinite from 'lodash/isFinite';

export function formatCurrency(price?: number | string | null, trim = false) {
  if (typeof price === 'undefined' || price === null) {
    return '-';
  }

  const parsed = typeof price === 'string' ? parseFloat(price) : price;
  const displayPrice = Math.abs(parsed).toFixed(2);
  const negative = parsed < 0;

  if (!isFinite(parsed)) {
    return '-';
  }

  // If trim is true and the number is a whole number, use 0 decimal places
  const minimumFractionDigits = trim && parsed % 1 === 0 ? 0 : 2;
  const maximumFractionDigits = 2;

  return `${negative ? '-' : ''}$${Number(displayPrice).toLocaleString(
    'en-US',
    {
      minimumFractionDigits,
      maximumFractionDigits,
    }
  )}`;
}
